// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Vector.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  --btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;
  --btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;
  --dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;
}

.navbar {
  width: 100%;
  height: 3rem;
  color: #426ba6;
  z-index: 150;
  background: #bfcde2;
  border: 0.3px solid #88a5cf;
  border-radius: 0px 0px 1px 1px;
  display: flex;
  justify-content: center;
  position: absolute;
  min-width: 1024px;
}
.navbar__container {
  width: 100%;
  max-width: 2000px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 2px 1rem;
}
@media screen and (min-width: 1440px) {
  .navbar__container {
    padding: 2px 2rem;
  }
}
.navbar__logo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 5px;
  height: 30px;
}
@media screen and (min-width: 1440px) {
  .navbar__logo {
    gap: 10px;
  }
}
.navbar h1 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: clamp(0.5rem, 0.9vw, 0.85rem);
  display: flex;
  align-items: center;
}
.navbar__datetime_wrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 19px;
  gap: 2em;
  width: 100%;
}
.navbar__datetime {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
}
@media screen and (min-width: 1440px) {
  .navbar__datetime {
    margin-left: 0;
  }
}
.navbar .user_label__container {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
  /* height: 1.5em; */
  font-weight: 500;
  font-size: 1em;
  line-height: 1.2em;
}
.navbar .user_label__container img {
  width: 1em;
  height: 1.1em;
  margin-left: 0.5em;
  margin-top: 0.2em;
  cursor: pointer;
}
.navbar .user_label {
  display: block;
  width: auto;
  /*  */
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media screen and (max-width: 1300px) {
  .navbar .user_label {
    max-width: 80px;
  }
}
.navbar .user_label span {
  padding-bottom: 0.1em;
  font-size: 1em;
}
.navbar ul {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 5px;
  margin: 0 20px;
  padding-inline-start: 0;
}
@media screen and (min-width: 1440px) {
  .navbar ul {
    gap: 10px;
  }
}
.navbar__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
}
.navbar__lang-switch {
  margin-right: 5px;
}
.navbar a {
  text-decoration: none;
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), pointer;
  color: #426ba6;
}
@media screen and (max-width: 1440px) {
  .navbar {
    font-size: 11px;
    line-height: 12px;
  }
}
@media screen and (min-width: 1440px) {
  .navbar {
    font-size: 12px;
    line-height: 14px;
  }
}

.nav-item {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), pointer;
  list-style: none;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1.1em;
  line-height: 1.3em;
  color: #426ba6;
  height: 100%;
  padding: 1px 4px;
}
.nav-item a {
  font-weight: 500;
}
@media screen and (min-width: 1440px) {
  .nav-item {
    padding: 1px 6px;
  }
}

.navTitle {
  display: inline-block;
  transition: transform 0.3s ease;
  will-change: transform;
}
.navTitle:hover {
  transform: translate(1px, 1px);
}

.dropdown {
  display: block;
  position: absolute;
  z-index: 1;
  width: auto;
  min-width: 100px;
  background-color: white;
  border: 1px solid rgba(66, 108, 166, 0.368627451);
  box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;
}
.dropdown span {
  padding: 0;
  margin-right: 5px;
  margin-left: 3px;
}
.dropdown a {
  font-weight: 400;
}
.dropdown a:hover {
  color: rgba(136, 166, 207, 0.8666666667);
}

.menu-item {
  height: 18px;
}
.menu-item a {
  font-weight: 400;
}
.menu-item a:hover {
  color: rgba(136, 166, 207, 0.8666666667);
}

.settings-menu-items {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.settings-menu-items button {
  width: 100%;
  text-align: left;
}

.bold {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/Components/App/vars.scss","webpack://./src/Components/NavBar/src/NavBar.scss"],"names":[],"mappings":"AA8CA;EACE,sDAAA;EACA,0DAAA;EACA,2GAAA;EACA,kDAAA;AC7CF;;AAJA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AAOF;AALE;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AAOJ;AANI;EARF;IASI,iBAAA;EASJ;AACF;AAPE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;AASJ;AARI;EARF;IASI,SAAA;EAWJ;AACF;AATE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EAEA,aAAA;EACA,mBAAA;AAUJ;AAPE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;AASJ;AAPE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AASJ;AALI;EAPF;IAQI,cAAA;EAQJ;AACF;AALE;EACE,aAAA;EAEA,WAAA;EAEA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAKJ;AAJI;EACE,UAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAMN;AAHE;EAEE,cAAA;EACA,WAAA;EACA,KAAA;EACA,uBAAA;EACA,mBAAA;AAIJ;AAFI;EARF;IASI,eAAA;EAKJ;AACF;AAHE;EACE,qBAAA;EACA,cAAA;AAKJ;AAFE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,uBAAA;AAIJ;AAHI;EAPF;IAQI,SAAA;EAMJ;AACF;AAHE;EAEE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AAIJ;AADE;EACE,iBAAA;AAGJ;AAEE;EACE,qBAAA;EACA,wDAAA;EACA,cAAA;AAAJ;AAGE;EAvIF;IAwII,eAAA;IACA,iBAAA;EAAF;AACF;AACE;EA3IF;IA4II,eAAA;IACA,iBAAA;EAEF;AACF;;AAAA;EACE,wDAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAGF;AADE;EACE,gBAAA;AAGJ;AADE;EAfF;IAgBI,gBAAA;EAIF;AACF;;AADA;EACE,qBAAA;EAEA,+BAAA;EACA,sBAAA;AAGF;AADE;EACE,8BAAA;AAGJ;;AACA;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,iDDvLY;ECwLZ,iFAAA;AAEF;AADE;EACE,UAAA;EACA,iBAAA;EACA,gBAAA;AAGJ;AADE;EACE,gBAAA;AAGJ;AAFI;EACE,wCAAA;AAIN;;AAAA;EACE,YAAA;AAGF;AAFE;EACE,gBAAA;AAIJ;AAHI;EACE,wCAAA;AAKN;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAGF;AADE;EACE,WAAA;EACA,gBAAA;AAGJ;;AACA;EACE,iBAAA;AAEF","sourcesContent":["$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$borderColorLight: #dae1ec;\n$accentFilterColor: #ff8040;\n$accentColor: #b72025;\n$warningColor: #d3c71c;\n$succesColor: #00dbbb;\n$accentTableRowColor: #ecc0c1;\n$filtersBgColor: #d6dfea71; //#d6dfea\n$filterTitleColor: #d6dfea93;\n$textColor: #426ba6;\n$filtersBorderColor: #426ba6;\n$deletedTextColor: #b72025;\n$iconFill: #829ec4;\n$logoIcon: #6d91c6;\n$activeBtnColor: rgba(218, 225, 236, 1);\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n$btnBoxShadow: rgba(96, 94, 94, 0.25) 1.45px 1.45px 2.1px;\n$reactTableShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$btnHoverBoxShadow: rgba(52, 51, 51, 0.25) 1.45px 1.45px 2.1px 1px, rgba(96, 94, 94, 0.25) 0px 0.5px 0.5px;\n$dividerShadow: rgba(0, 0, 0, 0.24) 0px 1px 1.5px;\n$commonShadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;\n$commonShadowHover: rgba(67, 71, 85, 0.27) 1px 1px 0.25em, rgba(90, 125, 188, 0.05) 1px 0.3em 1em;\n\n$transition: ease;\n$transitionFunc: cubic-bezier(0.25, 1, 0.5, 1);\n$iconHoverTransition: cubic-bezier(0.22, 1, 0.36, 1);\n$commonTransition: 0.3s $transitionFunc;\n\n:root {\n  --filterBtnBoxShadow: #{$filterBtnBoxShadow};\n  --btnBoxShadow: #{$btnBoxShadow};\n  --btnHoverBoxShadow: #{$btnHoverBoxShadow};\n  --dividerShadow: #{$dividerShadow};\n}\n\n$main-font: \"Roboto\", sans-serif;\n\n$font-weights: (\n  \"Light\": 300,\n  \"Regular\": 400,\n  \"Medium\": 500,\n  \"Bold\": 700,\n);\n","@import \"../../App/vars.scss\";\n.navbar {\n  width: 100%;\n  height: 3rem;\n  color: #426ba6;\n  z-index: 150;\n  background: #bfcde2;\n  border: 0.3px solid #88a5cf;\n  border-radius: 0px 0px 1px 1px;\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  min-width: 1024px;\n\n  &__container {\n    width: 100%;\n    max-width: 2000px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 2px 1rem;\n    @media screen and (min-width: 1440px) {\n      padding: 2px 2rem;\n    }\n  }\n  &__logo {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0px;\n    gap: 5px;\n    height: 30px;\n    @media screen and (min-width: 1440px) {\n      gap: 10px;\n    }\n  }\n  h1 {\n    font-family: \"Roboto\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: clamp(0.5rem, 0.9vw, 0.85rem);\n    // line-height: 18px;\n    display: flex;\n    align-items: center;\n  }\n\n  &__datetime_wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    height: 19px;\n    gap: 2em;\n    width: 100%;\n  }\n  &__datetime {\n    display: flex;\n    flex-direction: column;\n    margin-left: 5px;\n    h1 {\n      // width: 100px;\n    }\n    @media screen and (min-width: 1440px) {\n      margin-left: 0;\n    }\n  }\n\n  .user_label__container {\n    display: flex;\n    // flex-direction: row;\n    width: 100%;\n    // text-align: right;\n    align-items: center;\n    justify-content: flex-end;\n    /* height: 1.5em; */\n    font-weight: 500;\n    font-size: 1em;\n    line-height: 1.2em;\n    img {\n      width: 1em;\n      height: 1.1em;\n      margin-left: 0.5em;\n      margin-top: 0.2em;\n      cursor: pointer;\n    }\n  }\n  .user_label {\n    // padding-right: 2rem;\n    display: block;\n    width: auto;\n    /*  */\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    @media screen and (max-width: 1300px) {\n      max-width: 80px;\n    }\n  }\n  .user_label span {\n    padding-bottom: 0.1em;\n    font-size: 1em;\n  }\n\n  ul {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    gap: 5px;\n    margin: 0 20px;\n    padding-inline-start: 0;\n    @media screen and (min-width: 1440px) {\n      gap: 10px;\n    }\n  }\n\n  &__right {\n    // margin-left: auto;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 14px;\n  }\n\n  &__lang-switch {\n    margin-right: 5px;\n  }\n\n  p {\n  }\n  a {\n    text-decoration: none;\n    cursor: url(\"Vector.png\"), pointer;\n    color: #426ba6;\n  }\n\n  @media screen and (max-width: 1440px) {\n    font-size: 11px;\n    line-height: 12px;\n  }\n  @media screen and (min-width: 1440px) {\n    font-size: 12px;\n    line-height: 14px;\n  }\n}\n.nav-item {\n  cursor: url(\"Vector.png\"), pointer;\n  list-style: none;\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 1.1em;\n  line-height: 1.3em;\n  color: #426ba6;\n  height: 100%;\n  padding: 1px 4px;\n\n  a {\n    font-weight: 500;\n  }\n  @media screen and (min-width: 1440px) {\n    padding: 1px 6px;\n  }\n}\n\n.navTitle {\n  display: inline-block;\n\n  transition: transform 0.3s ease;\n  will-change: transform;\n\n  &:hover {\n    transform: translate(1px, 1px);\n  }\n}\n\n.dropdown {\n  display: block;\n  position: absolute;\n  z-index: 1;\n  width: auto;\n  min-width: 100px;\n  background-color: white;\n  border: $border-thin;\n  box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;\n  span {\n    padding: 0;\n    margin-right: 5px;\n    margin-left: 3px;\n  }\n  a {\n    font-weight: 400;\n    &:hover {\n      color: #88a6cfdd;\n    }\n  }\n}\n.menu-item {\n  height: 18px;\n  a {\n    font-weight: 400;\n    &:hover {\n      color: #88a6cfdd;\n    }\n  }\n}\n\n.settings-menu-items {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  button {\n    width: 100%;\n    text-align: left;\n  }\n}\n\n.bold {\n  font-weight: bold;\n}\n\n// @media screen and (min-width: 1805px) {\n//   .navbar {\n//     height: 43px;\n//     li,\n//     h1 {\n//       font-size: 15px;\n//       line-height: 20px;\n//     }\n//   }\n// }\n// @media screen and (min-width: 1905px) {\n//   .navbar {\n//     height: 45px;\n//     li,\n//     h1 {\n//       font-size: 15px;\n//       line-height: 22px;\n//     }\n//   }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
